module.exports = __webpack_public_path__ + "img/banner5.623d4856.png";